export const translations = {
  es: {
    nav: {
      home: "Inicio",
      about: "Quiénes Somos",
      services: "Servicios",
      iieas: "Instituto IIEAS",
      synapse: "Convergen Synapse",
      insights: "Insights",
      contact: "Contacto",
      cta: "Contacto",
    },
    footer: {
      tagline: "El punto donde convergen la evidencia, la transformación y el acceso a la salud.",
      rights: "Todos los derechos reservados.",
      sections: "Navegación",
      contact: "Contacto",
      legal: "Legal",
      privacy: "Aviso de Privacidad",
      terms: "Términos",
    },
    home: {
      eyebrow: "Consultoría estratégica en salud",
      hero_title_1: "El punto donde convergen",
      hero_title_2: "la evidencia, el negocio y el acceso.",
      hero_sub:
        "Operamos como articuladores estratégicos del ecosistema sanitario. Resolvemos la brecha entre la innovación biomédica y el acceso efectivo, centrando cada decisión en el paciente y en resultados en salud comprobables.",
      hero_cta: "Contacto",
      hero_secondary: "Conoce el modelo",
      challenge_eyebrow: "El Desafío",
      challenge_title: "La Brecha de Acceso",
      challenge_p1:
        "El diseño del sistema de salud contemporáneo exige soluciones operativas que superen la fragmentación y los esfuerzos aislados.",
      challenge_p2:
        "La evidencia es contundente: no basta con innovar en la molécula o en el dispositivo médico. El verdadero desafío sistémico radica en la cadena de acceso — garantizar que la innovación llegue al paciente correcto, en el tiempo oportuno, bajo las condiciones clínicas y financieras adecuadas.",
      evolution_eyebrow: "Nuestra Evolución Estratégica",
      evolution_title: "De la venta de cajas a la captura de resultados.",
      evolution_p:
        "Lideramos un cambio de paradigma: abandonar la visión lineal de \"venta de unidades\" para transitar hacia la captura de participación basada en pacientes con resultados comprobables. Las métricas dejan de medirse en inventarios desplazados y comienzan a medirse en vidas impactadas y progresión clínica evitada.",
      from: "De",
      to: "A",
      from_label: "Venta de cajas",
      to_label: "Resultados en salud",
      mosaic_eyebrow: "Tres Ramas, Una Visión",
      mosaic_title: "Explora el ecosistema Convergen",
      tile_consulting_title: "Consultoría Estratégica",
      tile_consulting_desc:
        "Los 4 Pilares: Patient Journey, gestión de resultados, gobernanza híbrida y acceso basado en valor.",
      tile_iieas_title: "Instituto IIEAS",
      tile_iieas_desc:
        "Brazo académico independiente. White papers, consensos y diplomados que cimentan política pública a largo plazo.",
      tile_synapse_title: "Convergen Synapse",
      tile_synapse_desc:
        "Inteligencia de datos aplicada a la salud. IA y plataformas para Organizaciones de Pacientes.",
      explore: "Explorar",
    },
    indicators: {
      eyebrow: "Indicadores de Convergencia",
      title: "Métricas que cuentan, no que adornan.",
      sub: "Nuestro impacto se mide en resultados clínicos y poblacionales tangibles, no en transacciones. Las cifras evolucionan con cada proyecto.",
      disclaimer: "* Indicadores agregados del modelo Convergen — actualización trimestral.",
      items: [
        { value: 2.4, decimals: 1, suffix: "M", label: "Vidas con acceso facilitado a tratamientos crónicos y de alta especialidad." },
        { value: 42, suffix: "", label: "Rutas de paciente optimizadas en ecosistemas público, privado e híbrido." },
        { value: 18, suffix: "", label: "Políticas públicas y procesos institucionales influenciados con evidencia local." },
        { value: 96, suffix: "%", label: "Decisiones de acceso respaldadas por Real-World Evidence o PROs." },
      ],
    },
    industries: {
      eyebrow: "Convergen articula",
      title: "Organizaciones que confían en el modelo.",
      sub: "Operamos bajo acuerdos de confidencialidad estrictos. En lugar de logos, compartimos los sectores que articulamos día a día.",
      note: "Sin logos · Sin nombres · Sólo trayectoria.",
      items: [
        { count: "10+", title: "Farmacéuticas globales y nacionales", desc: "Compañías de innovación biofarmacéutica y especialidad con presencia en LATAM." },
        { count: "06", title: "Asociaciones y ONGs de pacientes", desc: "Organizaciones de la sociedad civil que estructuran evidencia y articulan rutas de acceso." },
        { count: "03", title: "Instituciones de seguridad social pública", desc: "Pagadores y gestores de fondos con responsabilidad poblacional." },
        { count: "05", title: "Redes Privadas", desc: "Farmacias de especialidad y PAPs." },
      ],
    },
    about: {
      eyebrow: "Quiénes Somos",
      title: "Modelo operativo y metodología.",
      lead:
        "Convergen Consultoría nace como el articulador estratégico que resuelve la brecha estructural del acceso a la salud. Operamos como puente crítico entre las necesidades reales del paciente y las soluciones del ecosistema completo.",
      methodology_title: "El Enfoque de la Convergencia",
      methodology_sub:
        "Nuestra metodología no es lineal; es un ecosistema interconectado basado en cinco dimensiones críticas.",
      dim_1_title: "Rigor Científico y Precisión Analítica",
      dim_1_desc:
        "Análisis profundo de evidencia clínica, económica y epidemiológica para identificar cuellos de botella y demostrar el valor real de las intervenciones.",
      dim_2_title: "Incidencia y Marco de Política Pública",
      dim_2_desc:
        "Soluciones pragmáticas desde el marco normativo actual, orientadas a corregir desinversiones históricas y promover modelos transparentes.",
      dim_3_title: "Sincronización Clínica orientada al Valor",
      dim_3_desc:
        "Evaluación constante del estado de salud poblacional para garantizar que cada peso invertido se traduzca en mejora cuantificable en salud.",
      dim_4_title: "Evidencia del Paciente (PROs)",
      dim_4_desc:
        "Integración técnica de Patient-Reported Outcomes y Real-World Evidence para evaluar impacto clínico y humanístico, legitimando política pública.",
      dim_5_title: "Gobernanza Colaborativa",
      dim_5_desc:
        "Articulamos redes de valor en el ecosistema híbrido (público, privado y social) para cohesionar incentivos y garantizar sustentabilidad del acceso.",
      operating_title: "Modelo de Operación",
      operating_sub:
        "Convergencia de Talento Senior. Rompemos jerarquías tradicionales y operamos como una red ágil de especialistas con trayectoria directiva.",
      cell_1_title: "Células de Especialización Estratégica",
      cell_1_desc:
        "Bespoke Squads ensamblados según necesidades del proyecto: HEOR, HTA, asuntos regulatorios, farmacoeconomía, política pública, comunicación corporativa, estrategia de negocios e ingeniería de datos.",
      cell_2_title: "Incidencia y Relacionamiento de Alto Nivel",
      cell_2_desc:
        "Integramos visión de líderes en sociedad civil, agrupaciones de defensa del paciente y ex-funcionarios de organismos reguladores. Soluciones clínicamente sólidas y políticamente viables.",
      cell_3_title: "Alineación Clínica y Operativa",
      cell_3_desc:
        "Perfiles médicos senior y gestores institucionales traducen la innovación biomédica en rutas clínicas accionables que atienden ineficiencias del viaje del paciente.",
    },
    services: {
      eyebrow: "Servicios y Soluciones",
      title: "Los cuatro pilares de la convergencia.",
      lead:
        "Combinamos metodología histórica con soluciones de vanguardia. Cuatro pilares estratégicos que integran ciencia, política pública, financiamiento y experiencia del paciente.",
      pillar_1_title: "Transformación Operativa y Experiencia del Paciente",
      pillar_1_sub: "Patient Journey & Operating Models",
      pillar_1_items: [
        {
          h: "Patient Journey Analytics",
          d: "Inmersión multidisciplinaria impulsada por datos. Mapeamos la ruta integral del paciente: barreras del entorno, rezagos clínicos e ineficiencias operativas. Aislamos puntos críticos de decisión para agilizar diagnóstico y tratamiento.",
        },
        {
          h: "Generación de Evidencia del Paciente",
          d: "Integración técnica de Patient-Reported Outcomes y Real-World Evidence para legitimar el impacto humanístico y justificar decisiones de acceso.",
        },
        {
          h: "Beyond the Molecule Solutions",
          d: "Migración del enfoque tradicional de venta de insumos hacia soluciones integrales que mejoran adherencia, manejo de la enfermedad y experiencia humana en salud.",
        },
        {
          h: "Análisis de Carga de Enfermedad",
          d: "Modelos epidemiológicos y predictivos que evalúan el impacto económico y social de padecimientos complejos en mercados público, privado e híbrido.",
        },
      ],
      pillar_2_title: "De la Transacción a la Gestión de Resultados",
      pillar_2_sub: "Outcomes-Based Business Model",
      pillar_2_items: [
        {
          h: "Evolución del Modelo de Negocio",
          d: "Lideramos el cambio radical de la \"venta de cajas\" hacia la captura de participación basada en pacientes con resultados comprobables.",
        },
        {
          h: "Beyond the Molecule",
          d: "Diseñamos soluciones integrales que rodean el tratamiento: adherencia sostenida, manejo integral de la enfermedad y transformación de la experiencia humana en salud.",
        },
        {
          h: "Corresponsabilidad Poblacional",
          d: "Al transformar la eficacia teórica en resultados reales, demostramos a los pagadores que la inversión es clínica y financieramente sustentable.",
        },
      ],
      pillar_3_title: "Gobernanza en un Ecosistema Híbrido",
      pillar_3_sub: "Hybrid Ecosystem Governance",
      pillar_3_items: [
        {
          h: "Gobierno, Pagadores y Aseguradoras",
          d: "Articulamos instituciones públicas, aseguradoras privadas (GMM) y gestores de fondos para crear modelos de financiamiento complementarios y riesgo compartido.",
        },
        {
          h: "Proveedores Integrales de Salud",
          d: "Integramos hospitales, centros de infusión, laboratorios de diagnóstico clínico/genómico y clínicas de seguimiento para acompañar toda la trayectoria clínica.",
        },
        {
          h: "Think Tanks, Academia y Asociaciones",
          d: "Incorporamos validadores independientes que traducen evidencia clínica en recomendaciones de política pública estructuradas, centradas en pacientes.",
        },
        {
          h: "ONGs y Organizaciones de Pacientes",
          d: "Integramos su voz y evidencia técnica para consolidarlas como cocreadoras de rutas de acceso y vigilantes de la equidad.",
        },
      ],
      pillar_4_title: "Modelos de Financiamiento Innovador",
      pillar_4_sub: "Value-Based Access & Innovative Contracting",
      pillar_4_items: [
        {
          h: "Acceso Diferenciado y Riesgo Compartido",
          d: "Diseñamos modelos donde la inversión del pagador se condiciona al éxito clínico medible o a techos presupuestales por volumen poblacional, mitigando incertidumbre frente a terapias de alta especialidad.",
        },
        {
          h: "Sinergias del Ecosistema Híbrido",
          d: "Integramos redes de farmacias de especialidad y Programas de Apoyo a Pacientes (PAPs) para proteger financieramente al paciente y garantizar continuidad terapéutica.",
        },
        {
          h: "Evidencia Local para HTA",
          d: "Real-World Evidence local y datos estructurados por organizaciones de pacientes para construir expedientes farmacoeconómicos irrefutables que fundamentan decisiones del Consejo de Salubridad General.",
        },
      ],
    },
    iieas: {
      eyebrow: "IIEAS — Instituto de Investigación, Estrategia y Articulación en Salud",
      title: "El brazo académico y de pensamiento de Convergen.",
      lead:
        "Una base sólida y durable en el tiempo. Aprovecha la experiencia matriz de Convergen, pero opera de manera autónoma integrando la participación directa de líderes del gremio, academia y expertos de alto nivel.",
      objective_title: "Objetivo",
      objective_p:
        "Generar evidencia técnica, realizar investigación imparcial y crear espacios de debate inter-institucionales para cimentar políticas públicas a largo plazo, independientemente de los ciclos comerciales.",
      nature_label: "Naturaleza",
      nature_text: "Think-and-Do Tank académico y técnico.",
      role_label: "Rol Estratégico",
      role_text: "El brazo metodológico. Aquí se formulan las hipótesis, los Modelos Ponderados de Riesgo, el análisis comparativo internacional (UK/Canadá) y los planes de erradicación o contención epidemiológica. Es el puente entre la ciencia de datos y la política pública.",
      sustainability_label: "Sustentabilidad Financiera",
      sustainability_text: "Patrocinios de la industria biofarmacéutica y tecnológica para el desarrollo de White Papers, estudios de Evidencia del Mundo Real (RWE) independientes, foros de discusión técnica de alto nivel y programas de formación para \"Pacientes Expertos\".",
      products_title: "Productos del Instituto",
      product_1_h: "White Papers",
      product_1_d:
        "Documentos técnicos que estructuran evidencia clínica, económica y de política pública para incidir en decisiones de alto nivel.",
      product_2_h: "Consensos Multidisciplinarios",
      product_2_d:
        "Foros inter-institucionales con academia, gremios médicos, gobierno y sociedad civil para alinear lineamientos sobre acceso y equidad.",
      product_3_h: "Diplomados de Alta Especialidad",
      product_3_d:
        "Programas en evaluación económica y políticas de salud para formar líderes capaces de articular el ecosistema híbrido.",
      independence_title: "Independencia Intelectual",
      independence_p:
        "El Instituto opera bajo principios de imparcialidad técnica. Sus publicaciones no responden a intereses comerciales: responden a la evidencia y al interés público en salud.",
    },
    synapse: {
      eyebrow: "Convergen Synapse",
      title: "La Convergencia de la Inteligencia Artificial, los Datos y el Acceso a la Salud.",
      lead:
        "El diseño del sistema de salud contemporáneo genera diariamente millones de puntos de información. Sin embargo, los datos aislados no transforman realidades. En Convergen Synapse democratizamos la tecnología analítica avanzada para resolver la desorganización de la información empírica.",
      lead_2:
        "Desarrollamos herramientas empresariales accesibles que transforman datos complejos en evidencia técnica válida, potenciando la experiencia del usuario y dotando de rigor científico a proyectos de nicho y Organizaciones de la Sociedad Civil.",
      capabilities_title: "Capacidades Tecnológicas",
      capabilities_sub:
        "Traducimos rigor analítico en software intuitivo y escalable.",
      cap_1_h: "Agilidad Analítica",
      cap_1_d:
        "Extracción, limpieza, estructuración y ordenamiento acelerado de grandes volúmenes de datos sanitarios y gubernamentales.",
      cap_2_h: "Visibilidad para ONGs",
      cap_2_d:
        "Plataformas que capturan información empírica y la estructuran en bases de datos robustas, generando evidencia técnica irrefutable.",
      cap_3_h: "Gestión, Trazabilidad y Validación",
      cap_3_d:
        "Sistemas intuitivos que garantizan trazabilidad end-to-end. Cada dato cuenta con validación rigurosa de fuentes y transparencia total.",
      cap_4_h: "Soluciones Escalables",
      cap_4_d:
        "Modelos financieros accesibles para plataformas empresariales del tercer sector: homologación de datos, automatización de dossiers y agentes de IA.",
      impact_title: "El Impacto en el Ecosistema",
      impact_sub: "Potenciando la Voz del Paciente.",
      impact_p:
        "La tecnología carece de valor si no mejora el recorrido humano. Integrar estas herramientas permite realizar Patient Journey Analytics de alta precisión. Al dotar a las Organizaciones de Pacientes con IA y plataformas de estructuración de datos (PROs), las consolidamos como verdaderos validadores independientes y cocreadores de rutas de acceso equitativas.",
      catalog_title: "Catálogo de Servicios Tecnológicos",
      cat_1_h: "Arquitectura de Datos para el Tercer Sector",
      cat_1_d:
        "Auditoría, limpieza y estructuración de bases de datos empíricas de ONGs para su conversión en Real-World Evidence (RWE).",
      cat_2_h: "Agentes de Navegación Asistida (IA)",
      cat_2_d:
        "Implementación de asistentes virtuales (chatbots con IA) que guían al paciente a través de su ruta de acceso, mejorando adherencia y resolviendo dudas burocráticas o de tratamiento.",
      cat_3_h: "Automatización de Reportes de Impacto",
      cat_3_d:
        "Herramientas que generan automáticamente documentos técnicos, expedientes farmacoeconómicos y reportes de resultados en salud.",
    },
    contact: {
      eyebrow: "Contacto y Agendamiento Estratégico",
      title: "Diagnóstico de Convergencia",
      lead:
        "Una sesión inicial de 30 minutos con un Consultor Senior. Eliminamos la fricción de formularios largos: dinos quién eres y dónde necesitas apoyo, y te conectaremos directamente con la célula adecuada.",
      step: "Paso",
      of: "de",
      sector_q: "¿A qué sector representas?",
      sectors: ["Farmacéutica", "ONG / Asociación de Pacientes", "Dispositivos Médicos", "Institución Pública", "Aseguradora / GMM", "Otro"],
      dim_q: "¿En qué dimensión del ecosistema requieres apoyo?",
      dims: ["Patient Journey", "Asuntos Públicos y Política", "Desarrollo de Tecnología (Synapse)", "Investigación (IIEAS)", "Acceso Basado en Valor", "Otro"],
      details_q: "Tus datos para el diagnóstico",
      name: "Nombre completo",
      email: "Correo institucional",
      org: "Organización",
      message: "Cuéntanos brevemente tu reto",
      schedule_q: "Elige fecha y horario",
      date_label: "Fecha sugerida",
      time_label: "Horario preferido",
      back: "Anterior",
      next: "Siguiente",
      submit: "Confirmar diagnóstico",
      success_title: "¡Solicitud enviada!",
      success_body: "Un Consultor Senior se pondrá en contacto contigo dentro de las próximas 24 horas hábiles para confirmar la sesión.",
      another: "Enviar otra solicitud",
    },
    admin: {
      login_title: "Acceso administrador",
      login_sub: "Panel privado para gestión de leads.",
      email: "Correo",
      password: "Contraseña",
      enter: "Iniciar sesión",
      logout: "Cerrar sesión",
      dashboard: "Panel de Leads",
      welcome: "Bienvenido",
      total: "Leads totales",
      new: "Nuevos",
      by_sector: "Por sector",
      by_dim: "Por dimensión",
      table_name: "Nombre",
      table_email: "Correo",
      table_sector: "Sector",
      table_dim: "Dimensión",
      table_date: "Fecha",
      table_status: "Estado",
      table_actions: "Acciones",
      empty: "Aún no hay leads. Las solicitudes del formulario aparecerán aquí.",
      delete: "Eliminar",
      mark_contacted: "Contactado",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      iieas: "IIEAS Institute",
      synapse: "Convergen Synapse",
      insights: "Insights",
      contact: "Contact",
      cta: "Contact",
    },
    footer: {
      tagline: "Where evidence, business transformation and health access converge.",
      rights: "All rights reserved.",
      sections: "Navigation",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy",
      terms: "Terms",
    },
    home: {
      eyebrow: "Strategic Health Consulting",
      hero_title_1: "Where evidence, business",
      hero_title_2: "and access converge.",
      hero_sub:
        "We operate as the strategic articulator of the healthcare ecosystem. We close the gap between biomedical innovation and effective access, placing the patient and measurable health outcomes at the center of every decision.",
      hero_cta: "Contact",
      hero_secondary: "Explore the model",
      challenge_eyebrow: "The Challenge",
      challenge_title: "The Access Gap",
      challenge_p1:
        "Today's healthcare system demands operating solutions that overcome fragmentation and siloed efforts.",
      challenge_p2:
        "Evidence is conclusive: innovating in the molecule or device is not enough. The systemic challenge lies in the access chain — ensuring innovation reaches the right patient, at the right time, under the right clinical and financial conditions.",
      evolution_eyebrow: "Our Strategic Evolution",
      evolution_title: "From selling units to capturing outcomes.",
      evolution_p:
        "We lead a paradigm shift: leaving behind the linear vision of unit sales to capture market share based on patients with provable outcomes. Metrics move from inventory turnover to lives impacted and clinical progression averted.",
      from: "From",
      to: "To",
      from_label: "Unit sales",
      to_label: "Health outcomes",
      mosaic_eyebrow: "Three Branches, One Vision",
      mosaic_title: "Explore the Convergen ecosystem",
      tile_consulting_title: "Strategic Consulting",
      tile_consulting_desc:
        "The 4 Pillars: Patient Journey, outcomes management, hybrid governance and value-based access.",
      tile_iieas_title: "IIEAS Institute",
      tile_iieas_desc:
        "Independent academic arm. White papers, consensus and high-specialty programs that anchor long-term policy.",
      tile_synapse_title: "Convergen Synapse",
      tile_synapse_desc:
        "Data intelligence applied to health. AI and platforms for Patient Organizations.",
      explore: "Explore",
    },
    indicators: {
      eyebrow: "Convergence Indicators",
      title: "Metrics that count, not metrics that decorate.",
      sub: "Our impact is measured in tangible clinical and population outcomes, not transactions. Figures evolve with every engagement.",
      disclaimer: "* Aggregated indicators from the Convergen model — quarterly update.",
      items: [
        { value: 2.4, decimals: 1, suffix: "M", label: "Lives with facilitated access to chronic and high-specialty therapies." },
        { value: 42, suffix: "", label: "Patient routes optimized across public, private and hybrid ecosystems." },
        { value: 18, suffix: "", label: "Public policies and institutional processes influenced with local evidence." },
        { value: 96, suffix: "%", label: "Access decisions backed by Real-World Evidence or PROs." },
      ],
    },
    industries: {
      eyebrow: "Convergen articulates",
      title: "Organizations that trust the model.",
      sub: "We operate under strict confidentiality agreements. Instead of logos, we share the sectors we articulate every day.",
      note: "No logos · No names · Only trajectory.",
      items: [
        { count: "10+", title: "Global and national pharmaceuticals", desc: "Biopharmaceutical innovation and specialty companies operating in LATAM." },
        { count: "06", title: "Patient associations and NGOs", desc: "Civil society organizations that structure evidence and articulate access routes." },
        { count: "03", title: "Public social-security institutions", desc: "Payers and fund managers with population responsibility." },
        { count: "05", title: "Private Networks", desc: "Specialty pharmacies and Patient Support Programs." },
      ],
    },
    about: {
      eyebrow: "About Us",
      title: "Operating model and methodology.",
      lead:
        "Convergen Consulting was born as the strategic articulator that closes the structural gap of healthcare access. We operate as a critical bridge between real patient needs and the solutions of the full ecosystem.",
      methodology_title: "The Convergence Approach",
      methodology_sub:
        "Our methodology is not linear; it is an interconnected ecosystem built on five critical dimensions.",
      dim_1_title: "Scientific Rigor & Analytical Precision",
      dim_1_desc:
        "Deep analysis of clinical, economic and epidemiological evidence to identify bottlenecks and demonstrate real value.",
      dim_2_title: "Public Policy & Advocacy",
      dim_2_desc:
        "Pragmatic solutions within current normative frameworks, correcting historical underinvestment and promoting transparency.",
      dim_3_title: "Value-Oriented Clinical Sync",
      dim_3_desc:
        "Continuous assessment of population health vs. ecosystem alternatives, ensuring every peso invested translates into measurable improvement.",
      dim_4_title: "Patient Evidence (PROs)",
      dim_4_desc:
        "Technical integration of Patient-Reported Outcomes and Real-World Evidence to assess clinical and humanistic impact, legitimizing policy.",
      dim_5_title: "Collaborative Governance",
      dim_5_desc:
        "We articulate value networks across the hybrid (public-private-social) ecosystem, aligning incentives for long-term access sustainability.",
      operating_title: "Operating Model",
      operating_sub:
        "Senior Talent Convergence. We break with traditional hierarchies and operate as an agile network of specialists with executive trajectory.",
      cell_1_title: "Strategic Specialization Cells",
      cell_1_desc:
        "Bespoke Squads assembled per project: HEOR, HTA, regulatory affairs, pharmacoeconomics, public policy, corporate communications, business strategy and data engineering.",
      cell_2_title: "High-Level Engagement",
      cell_2_desc:
        "We integrate leaders from civil society, patient advocacy groups and former regulators. Solutions clinically sound and politically viable.",
      cell_3_title: "Clinical & Operational Alignment",
      cell_3_desc:
        "Senior medical profiles and institutional managers translate biomedical innovation into actionable clinical pathways.",
    },
    services: {
      eyebrow: "Services & Solutions",
      title: "The four pillars of convergence.",
      lead:
        "We combine proven methodology with cutting-edge solutions. Four strategic pillars integrating science, public policy, financing and patient experience.",
      pillar_1_title: "Operational Transformation & Patient Experience",
      pillar_1_sub: "Patient Journey & Operating Models",
      pillar_1_items: [
        { h: "Patient Journey Analytics", d: "Data-driven multidisciplinary immersion. We map the patient's full route: environmental barriers, clinical lags and operational inefficiencies. We isolate critical decision points to streamline diagnosis and treatment." },
        { h: "Patient Evidence Generation", d: "Technical integration of Patient-Reported Outcomes and Real-World Evidence to legitimize humanistic impact and justify access decisions." },
        { h: "Beyond the Molecule Solutions", d: "Shift from selling units to integral solutions that improve adherence, disease management and the human experience in health." },
        { h: "Disease Burden Analysis", d: "Epidemiological and predictive models that evaluate economic and social impact of complex conditions in public, private and hybrid markets." },
      ],
      pillar_2_title: "From Transaction to Outcomes Management",
      pillar_2_sub: "Outcomes-Based Business Model",
      pillar_2_items: [
        { h: "Business Model Evolution", d: "We lead the radical shift from \"selling units\" to capturing share based on patients with provable outcomes." },
        { h: "Beyond the Molecule", d: "We design integral solutions surrounding treatment: sustained adherence, integral disease management and patient experience transformation." },
        { h: "Population Co-Responsibility", d: "By converting theoretical efficacy into real outcomes, we demonstrate to payers that investment is clinically and financially sustainable." },
      ],
      pillar_3_title: "Governance in a Hybrid Ecosystem",
      pillar_3_sub: "Hybrid Ecosystem Governance",
      pillar_3_items: [
        { h: "Government, Payers & Insurers", d: "We articulate public institutions, private insurers and fund managers to build complementary and risk-sharing financing models." },
        { h: "Integrated Health Providers", d: "Hospitals, infusion centers, clinical/genomic labs and follow-up clinics that accompany the full clinical trajectory." },
        { h: "Think Tanks & Academia", d: "Independent validators that translate clinical evidence into structured policy recommendations centered on patients." },
        { h: "NGOs & Patient Organizations", d: "Their voice and technical evidence consolidate them as co-creators of access pathways and equity stewards." },
      ],
      pillar_4_title: "Innovative Financing Models",
      pillar_4_sub: "Value-Based Access & Innovative Contracting",
      pillar_4_items: [
        { h: "Differentiated Access & Risk Sharing", d: "Models where payer investment is conditioned on measurable clinical success or population budget caps, mitigating uncertainty for high-specialty therapies." },
        { h: "Hybrid Ecosystem Synergies", d: "Integration of specialty pharmacy networks and Patient Support Programs to protect patients financially and ensure therapeutic continuity." },
        { h: "Local Evidence for HTA", d: "Local Real-World Evidence and structured patient data to build irrefutable pharmacoeconomic dossiers for the General Health Council." },
      ],
    },
    iieas: {
      eyebrow: "IIEAS — Institute for Research, Strategy & Health Articulation",
      title: "The academic and think tank arm of Convergen.",
      lead:
        "A solid, lasting foundation. It leverages Convergen's matrix experience but operates autonomously, integrating direct participation of guild leaders, academia and senior-level experts.",
      objective_title: "Objective",
      objective_p:
        "Generate technical evidence, conduct impartial research and create inter-institutional debate forums to anchor long-term public policy, independent of commercial cycles.",
      nature_label: "Nature",
      nature_text: "Academic and technical Think-and-Do Tank.",
      role_label: "Strategic Role",
      role_text: "The methodological arm. Here we formulate hypotheses, Weighted Risk Models, international comparative analysis (UK/Canada) and epidemiological eradication or containment plans. The bridge between data science and public policy.",
      sustainability_label: "Financial Sustainability",
      sustainability_text: "Sponsorships from the biopharmaceutical and technology industry to develop White Papers, independent Real-World Evidence (RWE) studies, high-level technical forums and \"Expert Patient\" training programs.",
      products_title: "Institute Outputs",
      product_1_h: "White Papers",
      product_1_d:
        "Technical documents structuring clinical, economic and policy evidence to influence high-level decisions.",
      product_2_h: "Multidisciplinary Consensus",
      product_2_d:
        "Inter-institutional forums with academia, medical guilds, government and civil society aligned on access and equity guidelines.",
      product_3_h: "High-Specialty Programs",
      product_3_d:
        "Diploma programs in economic evaluation and health policy to form leaders capable of articulating the hybrid ecosystem.",
      independence_title: "Intellectual Independence",
      independence_p:
        "The Institute operates under principles of technical impartiality. Its publications respond to evidence and public health interest, not commercial pressure.",
    },
    synapse: {
      eyebrow: "Convergen Synapse",
      title: "The Convergence of AI, Data and Health Access.",
      lead:
        "Today's health system generates millions of data points daily. Yet isolated data does not transform realities. At Convergen Synapse we democratize advanced analytical technology to solve the disorganization of empirical information.",
      lead_2:
        "We build accessible enterprise tools that turn complex data into valid technical evidence, enhancing user experience and giving scientific rigor to niche projects and civil society organizations.",
      capabilities_title: "Technological Capabilities",
      capabilities_sub:
        "We translate analytical rigor into intuitive, scalable software.",
      cap_1_h: "Analytical Agility",
      cap_1_d:
        "Accelerated extraction, cleaning, structuring and ordering of large volumes of health and government data.",
      cap_2_h: "Visibility for NGOs",
      cap_2_d:
        "Platforms that capture empirical information and structure it into robust databases, generating irrefutable technical evidence.",
      cap_3_h: "Management, Traceability & Validation",
      cap_3_d:
        "Intuitive systems with end-to-end traceability. Each data point validated against rigorous sources for full transparency.",
      cap_4_h: "Scalable Solutions",
      cap_4_d:
        "Accessible financial models for enterprise platforms in the third sector: data normalization, dossier automation and AI agents.",
      impact_title: "Ecosystem Impact",
      impact_sub: "Empowering the Patient Voice.",
      impact_p:
        "Technology has no value unless it improves the human journey. These tools enable high-precision Patient Journey Analytics. By empowering Patient Organizations with AI and structured PRO platforms, we consolidate them as true independent validators and co-creators of equitable access routes.",
      catalog_title: "Technology Service Catalog",
      cat_1_h: "Data Architecture for the Third Sector",
      cat_1_d:
        "Audit, cleaning and structuring of empirical NGO databases for conversion into Real-World Evidence (RWE).",
      cat_2_h: "AI-Assisted Navigation Agents",
      cat_2_d:
        "Virtual assistants (AI chatbots) that guide the patient through their access route, improving adherence and resolving bureaucratic or treatment questions.",
      cat_3_h: "Impact Reporting Automation",
      cat_3_d:
        "Software that automatically generates technical documents, pharmacoeconomic dossiers and health outcomes reports.",
    },
    contact: {
      eyebrow: "Contact & Strategic Booking",
      title: "Convergence Diagnosis",
      lead:
        "A 30-minute session with a Senior Consultant. No long forms — tell us who you are and where you need support, and we'll connect you directly with the right cell.",
      step: "Step",
      of: "of",
      sector_q: "Which sector do you represent?",
      sectors: ["Pharmaceutical", "NGO / Patient Org", "Medical Devices", "Public Institution", "Insurer / GMM", "Other"],
      dim_q: "Which dimension of the ecosystem needs support?",
      dims: ["Patient Journey", "Public Affairs & Policy", "Technology (Synapse)", "Research (IIEAS)", "Value-Based Access", "Other"],
      details_q: "Your details for the diagnosis",
      name: "Full name",
      email: "Institutional email",
      org: "Organization",
      message: "Briefly describe your challenge",
      schedule_q: "Pick a date and time",
      date_label: "Suggested date",
      time_label: "Preferred time",
      back: "Back",
      next: "Next",
      submit: "Confirm diagnosis",
      success_title: "Request sent!",
      success_body: "A Senior Consultant will reach out within the next 24 business hours to confirm the session.",
      another: "Send another request",
    },
    admin: {
      login_title: "Administrator access",
      login_sub: "Private panel for lead management.",
      email: "Email",
      password: "Password",
      enter: "Sign in",
      logout: "Sign out",
      dashboard: "Lead Panel",
      welcome: "Welcome",
      total: "Total leads",
      new: "New",
      by_sector: "By sector",
      by_dim: "By dimension",
      table_name: "Name",
      table_email: "Email",
      table_sector: "Sector",
      table_dim: "Dimension",
      table_date: "Date",
      table_status: "Status",
      table_actions: "Actions",
      empty: "No leads yet. Form submissions will appear here.",
      delete: "Delete",
      mark_contacted: "Mark contacted",
    },
  },
};
